import { Box, Image } from '@chakra-ui/react';

import mastercard from '../../assets/images/mastercard.png';
import sepa from '../../assets/images/sepa.png';
import oxxo from '../../assets/images/oxxo.png';
import paypal from '../../assets/images/paypal.png';
import bank from '../../assets/images/bank.png';
import bacs from '../../assets/images/bacs.png';
import ideal from '../../assets/images/ideal.png';
import affirm from '../../assets/images/affirm.png';
import applepay from '../../assets/images/applepay.png';
import googlepay from '../../assets/images/googlepay.png';

const MethodIcon = ({ src }: any) => (
  <Box as="div">
    <Image src={src} w="30px" />
  </Box>
);

export const CardMethodIcon = () => (
  <>
    <Box as="div">
      <Image src={mastercard} w="30px" />
    </Box>
  </>
);

export const SepaMethodIcon = () => <MethodIcon src={sepa} />;
export const OxxoMethodIcon = () => <MethodIcon src={oxxo} />;
export const BankMethodIcon = () => <MethodIcon src={bank} />;
export const PaypalMethodIcon = () => <MethodIcon src={paypal} />;
export const BacsMethodIcon = () => <MethodIcon src={bacs} />;
export const IdealMethodIcon = () => <MethodIcon src={ideal} />;
export const AffirmMethodIcon = () => <MethodIcon src={affirm} />;
export const ApplePayMethodIcon = () => <MethodIcon src={applepay} />;
export const GooglePayMethodIcon = () => <MethodIcon src={googlepay} />;
